import { createSlice } from '@reduxjs/toolkit';
import { ReceivingsUpdateStateType } from 'src/types/receivingsUpdate';

const initialState: ReceivingsUpdateStateType = {
    loading: false,
    loadingMultiple: false,
};
export const receivingsUpdateSlice = createSlice({
    name: 'receivingsUpdate',
    initialState,
    reducers: {
        synchronizeReceivingsDCIXFetch: (state, action) => {
            state.loadingMultiple = true;
        },
        synchronizeReceivingsDCIXFetchSuccess: (state, action) => {
            state.loadingMultiple = false;
        },
        synchronizeReceivingsDCIXFetchFailure: (state, action) => {
            state.loadingMultiple = false;
        },
        patchReceivingFetch: (state, action) => {
            state.loading = true;
        },
        patchReceivingFetchSuccess: (state) => {
            state.loading = false;
        },
        patchReceivingFetchFailure: (state, action) => {
            state.loading = false;
            // Pokud chceš zpracovat chyby, můžeš je uložit do stavu
            // state.error = action.payload.error;
        },
        patchMultipleReceivingsFetch: (state, action) => {
            state.loadingMultiple = true;
        },
        patchMultipleReceivingsFetchSuccess: (state) => {
            state.loadingMultiple = false;
        },
        patchMultipleReceivingsFetchFailure: (state, action) => {
            state.loadingMultiple = false;
            // Pokud chceš zpracovat chyby, můžeš je uložit do stavu
            // state.errorMultiple = action.payload.error;
        }
    },
});

export const {
    synchronizeReceivingsDCIXFetch,
    synchronizeReceivingsDCIXFetchSuccess,
    synchronizeReceivingsDCIXFetchFailure,
    patchReceivingFetch,
    patchReceivingFetchSuccess,
    patchReceivingFetchFailure,
    patchMultipleReceivingsFetch,
    patchMultipleReceivingsFetchSuccess,
    patchMultipleReceivingsFetchFailure
} = receivingsUpdateSlice.actions;

export default receivingsUpdateSlice.reducer;
